import {
  Box,
  Checkbox,
  FormControlLabel,
  TextField,
} from '@mui/material'

type Props = {
  disabled: boolean
  edit: boolean
  recurrenceCount: number
  setRecurrenceCount: (count: number) => void
}

export default function RecurrenceInput({
  disabled,
  edit,
  recurrenceCount,
  setRecurrenceCount,
}: Props) {
  if (edit) return null

  const recurring = recurrenceCount > 1

  return (
    <Box>
      <FormControlLabel
        control={
          <Checkbox
            checked={recurring}
            disabled={disabled}
            onChange={(event) => setRecurrenceCount(event.target.checked ? 4 : 1)}
          />
        }
        label="Upprepa varje vecka"
      />
      {recurring && (
        <TextField
          fullWidth
          type="number"
          label="Antal tillfällen"
          inputProps={{ min: 2, max: 52 }}
          value={recurrenceCount}
          disabled={disabled}
          onChange={(event) => {
            const value = Number(event.target.value)
            if (!Number.isFinite(value)) return
            setRecurrenceCount(Math.min(Math.max(Math.floor(value), 2), 52))
          }}
        />
      )}
    </Box>
  )
}
